<template>

  <div v-if="loadingForm" class="px-4 py-3">
    <v-progress-linear :indeterminate="true" :color="app.color_name"></v-progress-linear>
  </div>

  <div v-else class="wrapper-profile-customer">
    <v-layout row wrap>
      <v-flex>
        <h2 class="customer-details-title">CUSTOMER DETAILS</h2>

        <div class="card customer-info-wrapper">
          <div class="card-body">
            <div class="test-data history-profile">
              <div  class="fl" style="padding-right:175px">
                <img :src=customer.avatar alt="avatar" width="150" class="img-rounded"/>
              </div>
              <div class="fl" style="width:28%;">
                <div><span class="fwb"><i class="fas fa-mobile-alt"></i> </span><span class="data-profile">{{customer.phone}}</span></div>
                <div><span class="fwb"><i class="fas fa-envelope"></i> </span><span class="data-profile">{{customer.email}}</span></div>
                <div><span class="fwb"><i class="fas fa-map-marker-alt"></i> </span>&nbsp;<span class="data-profile">{{city}}, {{country}}</span></div>
                <div><span class="fwb"><i class="fas fa-birthday-cake"></i></span>&nbsp;<span class="data-profile">{{customer.date_of_birth}}</span></div>
                <div><span class="fwb"><i class="fas fa-flag"></i></span>&nbsp;<span class="data-profile">{{customer.nationality}}</span></div>
                <div><span class="fwb"><i class="fas fa-venus-mars"></i></span>&nbsp;<span class="data-profile">{{customer.gender}}</span></div>
              </div>
              <div class="fl" style="width:28%;">
                <!--<div><span class="fwb">Name:</span>&nbsp;<span>{{customer.name}}</span></div>-->
                <div><span class="fwb">Client No:</span>&nbsp;<span>{{('000000'+customer.id).slice(-6)}}</span></div>
                <div><span class="fwb">Card No:</span>&nbsp;<span>{{customer.card_number}}</span></div>
                <div><span class="fwb">Date Joined:</span>&nbsp;<span>{{customer.created_at}}</span></div>
              </div>
              <!--<div class="fl" style="width:25%">
                <div><span class="fwb">DOB:</span>&nbsp;<span>{{customer.date_of_birth}}</span></div>
                <div><span class="fwb">Nationality:</span>&nbsp;<span>{{customer.nationality}}</span></div>
                <div><span class="fwb">Gender:</span>&nbsp;<span>{{customer.gender}}</span></div>
              </div>-->
              <div class="fl user-edit">
                <div class="icon-info mb-12" @click="dataForm = false; cancelForm = false; redeemForm = false; checkForm('editing')"><i class="fas fa-edit"></i></div>
              </div>
              <div class="clear" style="height:10px"></div>
            </div>
            <div><span class="font-34">{{customer.name}}</span></div>

      <!--<table class="profile-maininfo">
        <thead>
        <tr>
          <th>Available Points</th>
          <th>Balance Points</th>
          <th>Redeemed Points</th>
          <th>Last Active</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{points_earned - points_redeem}}</td>
          <td>{{points_balance}}</td>
          <td>{{points_spent}} </td>
          <td>{{customer.updated_at}}</td>
        </tr>
        </tbody>
      </table>--><!--
      <div class="ft"><span class="fwb">Available Points:</span><span>{{points_earned - points_redeem}}</span></div>
      <div class="ft"><span class="fwb">Balance Points:</span><span>{{points_balance}}</span></div>
      <div class="ft"><span class="fwb">Redeemed Points:</span><span>{{points_redeem}}</span></div>
      <div class="ft"><span class="fwb">Last Active:</span><span>{{customer.updated_at}}</span></div>-->
          </div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex class="pd-bottom-20">
        <div class="card customer-info-program-wrapper">
          <div class="card-body">
            <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
              <template v-for="(program, index) in programs">
              <li class="nav-item">
                <a v-bind:class="{ active: index == 0 }" class="nav-link profile-tabs" id="general_detail_tab" data-toggle="pill" v-bind:href="'#detail_'+program.id">{{program.name}}</a>
              </li><!--
              <li class="nav-item">
                <a class="nav-link" id="activity_detail_tab" data-toggle="pill" href="#activity_detail">Activity</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="portfolio_detail_tab" data-toggle="pill" href="#portfolio_detail">Portfolio</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="settings_detail_tab" data-toggle="pill" href="#settings_detail">Settings</a>
              </li>-->
              </template>
              <li class="nav-item abs-right-list-first">
                  <button type="button" large @click="redeemForm = false; cancelForm = false; editingForm=false; checkForm('adding')" class="btn btn-success waves-effect waves-light" :disabled="dataForm">
                    {{ $t('Add Points') }}
                  </button>
              </li>
              <li class="nav-item abs-right-list-second">
                <button type="button" large @click="dataForm = false; cancelForm = false; editingForm=false; checkForm('redeem')" class="btn btn-warning waves-effect waves-light" :disabled="dataForm || (points_earned + points_redeem)<=0">
                    {{ $t('Redeem Points') }}
                  </button>
                  <div v-if="(points_earned - points_redeem)<=0" class="reason-no-points">(No points available)</div>
              </li>
            </ul>
          </div>
        </div><!--end card-body-->
      </v-flex>
    </v-layout>

    <!--<v-layout row wrap>
      <v-flex xs12 >
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <div class="btn-points-wrapper">
            <div class="fr btn-profile">
              <v-btn large @click="redeemForm = false; cancelForm = false; checkForm('adding')" class="mb-2" :disabled="dataForm">
                {{ $t('Add Points') }}
              </v-btn>
            </div>
            <div class="fr btn-profile">
              <v-btn large @click="dataForm = false; cancelForm = false; checkForm('redeem')" class="mb-2" :disabled="dataForm || (points_earned - points_redeem)<=0">
                {{ $t('Redeem Points') }}
              </v-btn>
              <div v-if="(points_earned - points_redeem)<=0" class="reason-no-points">(No points available)</div>
            </div>
          </div>
        </v-card-actions>
      </v-flex>
    </v-layout>-->
    <div class="tab-content detail-list" id="pills-tabContent">
      <template v-for="(program, index) in programs">
        <div class="tab-pane fade active" v-bind:class="{ show: index == 0 }" v-bind:id="'detail_'+program.id">
          <v-layout row wrap>
            <v-flex xs4 class="pd-right-25">
              <div class="card">
                <div class="card-body height-264">
                  <div class="text-navy font-18"><h2 class="lifetime-word">Lifetime</h2></div>
                  <div class="text-navy font-14"></div>
                  <div class="d-flex justify-content-between">
                    <img src="/images/site/visuals/monthly-re.png" style="z-index: 1" height="75" />
                    <div class="text-right">
                      <h2 class="mt-0 mb-2 font-weight-semibold total_purchase"><span class="currency-symbol">{{program.symbol}}</span>{{(program.shopping_value)}}</h2>
                      <h4 class="title-text mb-0 total_purchase_revenue">Revenue</h4>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between p-3 rounded stats_profile_main">
                    <div class="left-box">
                      <h4 class="mb-1 font-weight-semibold">{{(program.points_earned)}}</h4>
                      <p class="mb-0">Points Earned</p>
                    </div>
                    <div class="right-box">
                      <h4 class=" mb-1 font-weight-semibold">{{(program.points_redeemed)}}</h4>
                      <p class="mb-0">Points Redeemed</p>
                    </div>
                  </div>
                </div><!--end card-body-->
              </div>
            </v-flex>
            <v-flex xs8>
              <v-layout row wrap>
                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-lock-open bg-soft-warning"></i></div>
                      <h3 class="text-navy">{{(program.points_earned + program.points_redeemed)}}</h3>
                      <h6 class="font-14 text-navy">Available Points</h6>
                    </div><!--end card-body-->
                  </div>
                </v-flex>
                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-lock bg-soft-pink"></i></div>
                      <h3 class="text-navy font-30">{{(program.points_balance - program.points_earned)}}</h3>
                      <h6 class="font-14 text-navy">Balance Points</h6>
                    </div><!--end card-body-->
                  </div>
                </v-flex>
                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-hand-holding-usd bg-soft-success"></i></div>
                      <h3 class="text-navy"><span class="currency-symbol">{{program.symbol}}</span>{{(program.discount_balance)}}</h3>
                      <h6 class="font-14 text-navy">Discount Balance</h6>
                    </div><!--end card-body-->
                  </div>
                </v-flex>
                <v-flex xs3 class="pd-lateral-10">
                  <div class="card dash-data-card text-center">
                    <div class="card-body height-264">
                      <div class="icon-info mb-12"><i class="fas fa-history bg-soft-primary"></i></div>
                      <h3 class="text-navy">{{program.last_update}}</h3>
                      <h6 class="font-14 text-navy">Last Active</h6>
                      <!--<h3 class="text-dark">5 days ago</h3>-->
                    </div><!--end card-body-->
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 class="margin-t-35">
              <div class="card">
                <div class="card-body">
                  <h4 class="header-title mt-0 mb-3">Customer History</h4>
                  <div class="table-responsive browser_users">
                    <div v-if="loadingHistory" class="px-4 py-3">
                      <v-progress-linear :indeterminate="true" :color="app.color_name"></v-progress-linear>
                    </div>

                    <v-data-table
                            :headers="headersHistory"
                            :items="program.histories"
                            :items-per-page="5"
                            class="elevation-1"
                            show-expand
                            :single-expand="true"
                    >

                      <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length"  v-if="item.items.length > 0">
                          <table class="fullwidth">
                            <thead>
                            <tr>
                              <th>Item</th>
                              <th>Sku</th>
                              <th>Total</th>
                              <th></th>
                            </tr>
                            </thead>
                            <tr v-for="(i, idx) in item.items">
                              <td align="left">{{i.name}}</td>
                              <td align="left">{{i.sku }}</td>
                              <td align="left">{{i.total}} </td>
                              <td align="left">
                                <a href="#" v-if="i.pivot.status==='add'" @click="removeItemFromHistory(item, i)">Cancel</a>
                                <span v-if="i.pivot.status!=='add'">its been Cancelled</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </template>

                      <template v-slot:item.shopping_value = {item}>
                          <span v-if="item.currency && item.currency.code">{{ item.currency.code }}</span>&nbsp;{{ item.shopping_value }}
                      </template>

                      <template v-slot:item.actions = {item}>
                        <a href="#" @click="removeHistory(item)" v-if="
                        item.event.category!=='signup' &&
                        item.event.category!=='first-purchase' &&
                        item.active!=0 &&
                        !item.first_purchase &&
                        item.items.length === 0">Cancel</a>
                      </template>

                    <!--<table class="table mb-0" v-if="!loadingHistory">
                      <thead class="thead-light">
                      <tr>
                        <th class="border-top-0"><span></span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('created_at')"><span>Time & Date</span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('location')"><span>POS</span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('staff')"><span>Staff</span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('event')"><span>Description</span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('transaction_number')"><span>Receipt Ref</span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('points')"><span>Points</span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('shopping_value')"><span>Amount</span></th>
                        <th class="border-top-0 sorting" @click="orderHistory('points_redeemed')"><span></span></th>
                      </tr>&lt;!&ndash;end tr&ndash;&gt;
                      </thead>
                      <tbody>-->
                     <!-- <template v-for="(item, index) in program.histories">-->
                      <!--<template v-slot:item.ext-="{item}">werewrwer
                        <span v-if="!opened.includes(item.id) && item.items.length > 0" @click="toggle(item.id)">
                          <i class="v-icon fas fa-plus-circle" style="font-size: 14px;"></i>
                        </span>
                        <span v-if="opened.includes(item.id)" @click="toggle(item.id)">
                          <i class="v-icon fas fa-minus-circle" style="font-size: 14px;"></i>
                        </span>
                      </template>

                      <template v-slot:item.time-="{item}">
                        <span>{{item.created_at}}</span>
                      </template>

                      <template v-slot:item.pos-="{item}">
                        <span>{{ item.location && item.location.google_links ? item.location.google_links : item.location }}</span>
                      </template>

                      <template v-slot:item.staff-="{item}">
                        <span>{{item.staff ? item.staff : '' }}</span>
                      </template>

                      <template v-slot:item.event-="{item}">
                        <span>{{ item.event && item.event.name ? item.event.name : item.event }}</span>
                      </template>

                      <template v-slot:item.receipt-="{item}">
                        <span>{{item.transaction_number}}</span>
                      </template>

                      <template v-slot:item.points-="{item}">
                        <span  v-if="isPoint(item.program, item)">{{item.points}}</span>
                        <span  v-if="!isPoint(item.program, item)">-</span>
                      </template>

                      <template v-slot:item.amount-="{item}">
                        <span>{{item.shopping_value}}</span>
                      </template>-->

                      <!--<tr>
                        <td>
                          <span v-if="!opened.includes(item.id) && item.items.length > 0" @click="toggle(item.id)">
                            <i class="v-icon fas fa-plus-circle" style="font-size: 14px;"></i>
                          </span>
                          <span v-if="opened.includes(item.id)" @click="toggle(item.id)">
                            <i class="v-icon fas fa-minus-circle" style="font-size: 14px;"></i>
                          </span>
                        </td>-->
                          <!--<td><span>{{item.created_at}}</span></td>
                          <td>{{ item.location && item.location.google_links ? item.location.google_links : item.location }}</td>
                          <td>{{item.staff ? item.staff : '' }}</td>
                          <td>{{ item.event && item.event.name ? item.event.name : item.event }}</td>
                          <td>{{item.transaction_number}}</td>
                          <td>
                            <span  v-if="isPoint(item.program, item)">{{item.points}}</span>
                            <span  v-if="!isPoint(item.program, item)">-</span>
                          </td>
                          <td>{{item.shopping_value}}</td>
                          <td>
                            &lt;!&ndash;<span  v-if="!isBalance(item.program, item)">-</span>&ndash;&gt;
                              <a href="#" @click="removeHistory(item)" v-if="item.event.category!=='signup' && item.active!=0 && !item.first_purchase"><small>Cancel</small></a>
                          </td>
                          &lt;!&ndash; <td>
                             <span  v-if="isPoint(item.program, item)">{{item.points}}</span>
                             <span  v-if="!isPoint(item.program, item)">-</span>
                           </td>&ndash;&gt;
                        </tr>&lt;!&ndash;end tr&ndash;&gt;
                        <tr v-if="opened.includes(item.id)" class="items-table">
                          <td colspan="9">
                            <table class="fullwidth">
                              <thead>
                              <tr>
                                <th>Item</th>
                                <th>Sku</th>
                                <th>Total</th>
                                <th></th>
                              </tr>
                              </thead>
                              <tr v-for="(i, idx) in item.items">
                                <td align="left">{{i.name}}</td>
                                <td align="left">{{i.sku }}</td>
                                <td align="left">{{i.total}} </td>
                                <td align="left"><a href="#" @click="removeItemFromHistory(item, i)">Cancel</a></td>
                              </tr>
                            </table>
                          </td>
                        </tr>-->
                      <!--</template>-->
<!--                      </tbody>
                    </table>&lt;!&ndash;end table&ndash;&gt;-->
                    </v-data-table>




                  </div><!--end /div-->
                </div><!--end card-body-->
              </div>
            </v-flex>
          </v-layout>



        </div>
      </template>
    </div>

      <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="editingForm" :dataForm="editingForm" @keydown.esc="editingForm = false">
          <data-form
                  v-if="editingForm && actionPoint==='editing'"
                  v-on:data-list-events="dataListEvents = $event"
                  :model="model"
                  :uuid="uuid"
          ></data-form>
      </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="dataForm" :dataForm="dataForm" @keydown.esc="dataForm = false">
      <data-form v-if="dataForm && actionPoint==='adding'" v-on:data-list-events="dataListEvents=$event" :model="model" :customer_id="customer.id"></data-form>
    </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="redeemForm" :dataForm="redeemForm" @keydown.esc="redeemForm = false">
      <data-form v-if="redeemForm && actionPoint==='redeem'" v-on:data-list-events="dataListEvents=$event" :model="model" :customer_id="customer.id"></data-form>
    </v-dialog>

    <v-dialog persistent :width="settings.dialog_width || 480" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="cancelForm" :dataForm="cancelForm" @keydown.esc="cancelForm = false">
      <data-form v-if="cancelForm && actionPoint==='deleting'" v-on:data-list-events="dataListEvents=$event" :model="model" :item="currentItem" :customer_id="customer.id"></data-form>
    </v-dialog>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        model: 'Platform\\Models\\History',
        customer: [],
        city: '',
        country: '',
        history: [],
        points_earned: 0,
        points_redeem: 0,
        points_spent: 0,
        points_balance: 0,
        shopping_value: 0,
        dataListEvents: null,
        redeemForm: false,
        editingForm: false,
        dataForm: false,
        cancelForm: false,
        currentItem: false,
        settings : {
          dialog_width: false
        },
        loadingForm: true,
        uuid: false,
        staff_creator:{},
        points_available: 0,
        today: new Date(),
        actionPoint: null,
        opened: [],
        loadingHistory: false,
        order: '',
        programs: [],
        headersHistory: [
          { text: 'Time & Date', value: 'created_at' },
          { text: 'POS', value: 'location.google_links' },
          { text: 'Staff', value: 'staff' },
          { text: 'Description', value: 'event.name' },
          { text: 'Receipt Ref', value: 'transaction_number' },
          { text: 'Points', value: 'points' },
          { text: 'Amount', value: 'shopping_value' },
          { text: '', value: 'actions' },
        ],
      }
    },
    computed: {
      app () {
        return this.$store.getters.app
      },
    },
    mounted() {
      this.uuid = this.$route.params.uuid;
      this.getDataFromApi().then(data => {
        console.log('job done')
      });

    },
    watch: {
      dataListEvents () {
        if (this.dataListEvents.closeDialog) {
          console.log('comes here close Dialog');
          this.dataForm = false;
          this.redeemForm = false;
          this.cancelForm = false;
          this.editingForm = false;
        }
        if (this.dataListEvents.reload) {
          console.log('comes here reload');
          this.reloadData()
        }
      }
    },
    methods: {
      toggle(id) {
        const index = this.opened.indexOf(id);
        if (index > -1) {
          this.opened.splice(index, 1)
        } else {
          this.opened.push(id)
        }
      },
      checkForm(action){
        this.actionPoint = action;
        switch (action) {
          case 'redeem' :
            this.redeemForm = true;
            this.model = 'Platform\\Models\\Redeem';
            break;
          case 'adding' :
            this.dataForm = true;
            this.model = 'Platform\\Models\\History';
            break;
        case 'editing' :
            this.editingForm = true;
            this.model = 'App\\Customer';
            break;
        }
      },
      orderHistory(column) {
        if (this.order == 'asc') {
          this.order = 'desc';
        } else {
          this.order = 'asc';
        }

        this.history = _.orderBy(this.history, column, this.order);
      },
      isBalance(program, item) {
        let check = false;
        if (program && program.points_expired_months && program.points_valid_date) {
          const day_expired = (moment(item.created_at).add(program.points_expired_months, 'M'));
          const day_valid = (moment(item.created_at).add(program.points_valid_date, 'd'));

          check = !moment().isAfter(day_expired) &&
                  !moment().isAfter(day_valid) &&
                  !item.force_point &&
                  !item.is_redeem &&
                  (item.event && item.event['category'] !== 'signup');
        }

        return (check && item.active);
      },
      isPoint(program, item) {
        let check = false;
        if (program && program.points_expired_months && program.points_valid_date>=0) {
          const day_expired = (moment(item.created_at).add(program.points_expired_months, 'M'));
          const day_valid = (moment(item.created_at).add(program.points_valid_date, 'd'));

          check = (!moment().isAfter(day_expired) && moment().isAfter(day_valid)) ||
                  (item.event && item.event['category'] === 'signup') ||
                  item.force_point ||
                  (item.event && item.event['category'] === 'cancel');
        }

        return check;
      },
      removeHistory(history) {
        this.dataForm = false;
        this.redeemForm = false;
        this.editingForm = false;
        this.cancelForm = true;
        this.actionPoint = 'deleting';
        this.model = 'Platform\\Models\\Cancellation';
        this.currentItem = history;
        //this.deleteRecords(history);
      },
      removeItemFromHistory(history, item){
        this.$root.$confirm(this.$t('delete'), this.$t('confirm_delete'))
                .then((confirm) => {
                  if (confirm) {
                    this.loading = true
                    let that = this
                    axios.post('app/history_item/delete', {
                      id: history.id,
                      item: item
                    }).then(res => {
                      if (res.data.status === 'success') {
                        this.reloadData()
                        this.$root.$snackbar(this.$t('items_deleted', { items: 1 }))
                      }
                    }).catch(err => {
                      if (err.response.data.status === 'error') {
                        this.$root.$snackbar(err.response.data.msg)
                        this.reloadData()
                      }
                    }).finally(() => that.loading = false)
                  }
                })
      },
      getDataFromApi() {
        this.loading = true
        return new Promise((resolve, reject) => {
          let that = this;
          axios.get('/app/customer/'+this.uuid).then(res => {
            if (res.status === 200) {
              this.customer = res.data.customer;
              this.customer.date_of_birth = moment(this.customer.date_of_birth).format('MM/DD/YYYY');
              this.customer.created_at = moment(this.customer.created_at).format('MM/DD/YYYY');
              this.city = res.data.city;
              this.country = res.data.country;
              /*this.city = res.data.city;
              this.country = res.data.country;
              this.history = res.data.history;
              this.staff_creator = res.data.staff_creator;
              this.points_earned = res.data.points_earned;
              this.points_balance = res.data.points_balance;
              this.points_redeem = res.data.points_redeem;
              this.points_spent = res.data.points_spent;
              this.shopping_value = res.data.shopping_value;*/
              this.points_earned = _.sumBy(res.data.programs, (program) => {
                return program.points_earned;
              }) || 0;
              this.points_redeem = _.sumBy(res.data.programs, (program) => {
                return program.points_redeem;
              }) || 0;

              this.programs = res.data.programs;
              this.loadingForm = false;
            }
          }).catch(err => console.log(err.response.data)).finally(() => that.loading = false);
        })
      },
      deleteRecords (history_id) {
        this.$root.$confirm(this.$t('delete'), this.$t('confirm_delete'))
                .then((confirm) => {
                  if (confirm) {
                    this.loading = true
                    let that = this
                    axios.post('app/history/delete', {
                      id: history_id
                    }).then(res => {
                      if (res.data.status === 'success') {
                        this.reloadData()
                        this.$root.$snackbar(this.$t('items_deleted', { items: 1 }))
                      }
                    }).catch(err => {
                      if (err.response.data.status === 'error') {
                        this.$root.$snackbar(err.response.data.msg)
                        this.reloadData()
                      }
                    }).finally(() => that.loading = false)
                  }
                })
      },
      reloadData () {
        this.watchPagination = false
        this.loading = true
        this.getDataFromApi()
                .then(data => {
                  this.rows = data.items
                  this.watchPagination = true
                })
      }
    }
  }
</script>